import * as ko from "knockout";
import * as _ from "underscore";
import { App } from "../app";
import { Api } from "../app-api";

const divRoot: HTMLDivElement = document.querySelector("#ko-account-order-details");
const divModel: HTMLDivElement = document.querySelector("#divAccountOrderDetailsModel");

export class AccountRegistrationCamp {
    id: number;
    canCancel: boolean;
    location: string;
    dates: string;
    times: string;

    constructor(data) {
        let self = this;

        self.id = data.id;
        self.canCancel = data.canCancel;
        self.location = data.location;
        self.dates = data.dates;
        self.times = data.times;
    }
}

export class AccountRegistrationExtraCare {
    id: number;
    name: string;
    amount: string;

    constructor(data) {
        let self = this;

        self.id = data.id;
        self.name = data.name;
        self.amount = data.amount;
    }
}

export class AccountRegistrationPaymentSummaryTax {
    name: string;
    amount: string;

    constructor(data) {
        let self = this;

        self.name = data.name;
        self.amount = data.amount;
    }
}

export class AccountRegistrationPromoCode {
    shortName: string;
    discountAmount: string;

    constructor(data) {
        let self = this;

        self.shortName = data.shortName;
        self.discountAmount = data.discountAmount;
    }
}

export class AccountRegistrationPaymentSummary {
    subtotal: string;
    total: string;
    promoCode: AccountRegistrationPromoCode;

    tax: AccountRegistrationPaymentSummaryTax[];

    constructor(data) {
        let self = this;

        self.subtotal = data.subtotal;
        self.total = data.total;
        self.tax = _(data.tax).map(x => new AccountRegistrationPaymentSummaryTax(x));

        if (data.promoCode)
            self.promoCode = new AccountRegistrationPromoCode(data.promoCode);
    }
}

export class AccountRegistrationRegistrant {
    id: number;
    fullName: string;
    birthDate: string;
    notes: string;

    constructor(data) {
        let self = this;

        self.id = data.id;
        self.fullName = data.fullName;
        self.birthDate = data.birthDate;
        self.notes = data.notes;
    }
}

export class AccountRegistrationSkillLevel {
    id: number;
    name: string;

    constructor(data) {
        let self = this;

        self.id = data.id;
        self.name = data.name;
    }
}

export class AccountRegistration {
    id: number;
    amount: string;
    subtotal: number;
    total: number;
    
    hasExtraCare = false;
    hasSkillLevelOptions: boolean;

    camp: AccountRegistrationCamp;
    payment: AccountRegistrationPaymentSummary;
    registrant: AccountRegistrationRegistrant;

    extraCare: AccountRegistrationExtraCare[];
    skillLevelOptions: AccountRegistrationSkillLevel[];

    showChangeLevel = ko.observable(false);

    skillLevel = ko.observable<AccountRegistrationSkillLevel>();
    selectedSkillLevel = ko.observable<AccountRegistrationSkillLevel>();

    filteredSkillLevels: ko.PureComputed<AccountRegistrationSkillLevel[]>;
    
    saveSkillLevel: () => void;
    toggleShowChangeLevel: () => void;

    hideCancelConfirm: () => void;
    showCancelConfirm: () => void;

    constructor(data: any, root: ViewModel) {
        let self = this;

        self.id = data.id;
        self.amount = data.amount;
        self.subtotal = data.subtotal;
        self.total = data.total;
        self.camp = new AccountRegistrationCamp(data.camp);
        self.payment = new AccountRegistrationPaymentSummary(data.payment);
        self.registrant = new AccountRegistrationRegistrant(data.registrant);
        

        self.hasExtraCare = _(data.extraCare).any();
        self.extraCare = _(data.extraCare).map(x => new AccountRegistrationExtraCare(x));

        self.hasSkillLevelOptions = data.skillLevelOptions.length > 1;
        self.skillLevelOptions = _(data.skillLevelOptions).map(x => new AccountRegistrationSkillLevel(x));
        self.skillLevel(_(self.skillLevelOptions).find(x => x.id == data.skillLevel));

        self.filteredSkillLevels = ko.pureComputed(() => {
            return _(self.skillLevelOptions).filter(x => x.id != self.skillLevel().id);
        }, self);

        self.showChangeLevel.subscribe(() => {
            if (self.hasSkillLevelOptions)
                $('.skill-level').slideToggle();
        });

        self.hideCancelConfirm = () => {
            root.selectedRegsitration(null);
        }

        self.showCancelConfirm = () => {
            root.selectedRegsitration(self);
        }

        self.saveSkillLevel = () => {
            self.updateSkillLevel(root);
        }

        self.toggleShowChangeLevel = () => {
            self.showChangeLevel(!self.showChangeLevel());
        }
    }

    private updateSkillLevel(root: ViewModel) {
        let self = this;

        root.busy(true);

        let data = {
            registration: self.id,
            skillLevel: self.selectedSkillLevel().id
        }

        Api.UpdateAccountSkillLevel(data)
            .done(results => {
                if (results.error) { return App.alertError(results.message); }

                App.alertSuccess("Your skill level has been updated.");
                self.skillLevel(_(self.skillLevelOptions).find(x => x.id == data.skillLevel));
            })
            .always(() => root.busy(false));
    }
}

export class ViewModel {
    id: number;
    created: string;
    credit: string;
    subtotal: string;
    total: string;
    cardRef: string;

    busy = ko.observable(false);

    selectedRegsitration = ko.observable<AccountRegistration>();

    registrations = ko.observableArray<AccountRegistration>();

    cancelRegistration: () => void;
    sendMail: () => void;

    constructor(model) {
        let self = this;

        let data = JSON.parse(model);

        self.id = data.id;
        self.created = data.created;
        self.subtotal = data.subtotal;
        self.credit = data.credit;
        self.total = data.total;
        self.cardRef = data.cardRef;

        let registrationsArray = _(data.registrations).map(x => new AccountRegistration(x, self))
        self.registrations(registrationsArray);

        self.busy.subscribe(newVal => {
            App.busy(newVal);
        });

        self.selectedRegsitration.subscribe(newVal => {
            let show = (newVal != null);
            //console.log('show: ' + String(show));
            App.toggleShowModal('cancelModal', show);
        });

        self.cancelRegistration = () => {
            if (self.busy()) { return; }
            if (self.selectedRegsitration() != null)
                self.cancelForCredit();
        }

        self.sendMail = () => {
            if (!self.busy()) {
                self.resendOrderConfirmation();
            }
        }
    }

    private cancelForCredit() {
        let self = this;

        self.busy(true);

        let registration = self.selectedRegsitration();

        let data = {
            registration: registration.id,
            subtotal: registration.subtotal,
            total: registration.total
        }

        Api.CancelForCredit(data)
            .done(results => {
                if (results.error) { return App.alertError(results.message); }
                self.registrations.remove(registration);

                if (_(self.registrations()).any()) {
                    App.alertSuccess("Your registration has been cancelled.");
                    self.selectedRegsitration(null);
                }
                else { window.location.href = results.nextUrl; }
            })
            .always(() => self.busy(false));
    }

    private resendOrderConfirmation() {
        let self = this;

        self.busy(true);

        let data = {
            order: self.id
        }

        Api.ResendOrderConfirmation(data)
            .done(results => {
                if (results.error) { return App.alertError(results.message); }
                App.alertSuccess("Your order confirmation email has been re-sent.");
            })
            .always(() => self.busy(false));
    }
}

function init() {
    if (divModel) {
        ko.applyBindings(new ViewModel(divModel.textContent), divRoot);
    }
}

$(document).ready(() => init());